import { AxiosError } from 'axios';
import { ActionType, createAction, createAsyncAction } from 'typesafe-actions';
import {
  AnalysisSimulatorData,
  AnalysisSimulatorLogData,
  AnalysisSimulatorState,
  AnalysisSimulatorStcsData
} from '../models/analysisSimulatorModel';

const LIST_REQUEST = 'anls/smlt/LIST_REQUEST';
const LIST_SUCCESS = 'anls/smlt/LIST_SUCCESS';
const LIST_FAILURE = 'anls/smlt/LIST_FAILURE';

const LOG_REQUEST = 'anls/smlt/LOG_REQUEST';
const LOG_SUCCESS = 'anls/smlt/LOG_SUCCESS';
const LOG_FAILURE = 'anls/smlt/LOG_FAILURE';

const DETAIL_REQUEST = 'anls/smlt/DETAIL_REQUEST';
const DETAIL_SUCCESS = 'anls/smlt/DETAIL_SUCCESS';
const DETAIL_FAILURE = 'anls/smlt/DETAIL_FAILURE';

const STATICS_REQUEST = 'anls/smlt/STATICS_REQUEST';
const STATICS_SUCCESS = 'anls/smlt/STATICS_SUCCESS';
const STATICS_FAILURE = 'anls/smlt/STATICS_FAILURE';

const DISPATCH_SEARCH = 'amls/smlt/DISPATCH_SEARCH';

const INIT_LIST = 'amls/smlt/INIT_LIST';

export const dispatchSearch =
  createAction(DISPATCH_SEARCH)<{ searchParams: string }>();

export const list = createAsyncAction(LIST_REQUEST, LIST_SUCCESS, LIST_FAILURE)<
  AnalysisSimulatorState,
  { data: AnalysisSimulatorData[]; count: number; total: number; page: number },
  AxiosError
>();

export const log = createAsyncAction(LOG_REQUEST, LOG_SUCCESS, LOG_FAILURE)<
  string,
  { log: AnalysisSimulatorLogData[] },
  AxiosError
>();

export const detail = createAsyncAction(
  DETAIL_REQUEST,
  DETAIL_SUCCESS,
  DETAIL_FAILURE
)<string, { data: AnalysisSimulatorData }, AxiosError>();

export const stcs = createAsyncAction(
  STATICS_REQUEST,
  STATICS_SUCCESS,
  STATICS_FAILURE
)<string, { data: AnalysisSimulatorStcsData[]; count: number }, AxiosError>();

const actions = {
  list,
  detail,
  log,
  stcs,
  dispatchSearch
};

export type AnalysisSimulatorAction = ActionType<typeof actions>;
